import React, { useCallback, useEffect, useState } from "react";
import {
    autorizarSaida,
    obterPessoasComSaidaNaoAutorizada,
} from "../../../api/requisicoes/registroAcessos";
import { normalizeString } from "../../../components/Funcoes";
import Loading from "../../../components/Loading";
import { useAlert } from "../../../context/AlertContext";
import { useConfirm } from "../../../context/ConfirmContext";
import {
    formatarDataBrasilia,
    formatarHoraBrasilia,
} from "../../../utils/functions";
import "./style.css";

const AutorizacaoSaidaMobile = () => {
    const [pessoas, setPessoas] = useState([]);
    const [filtro, setFiltro] = useState("");
    const [cartaoExpandidoId, setCartaoExpandidoId] = useState(null);
    const [carregando, setCarregando] = useState(false);

    const { showAlert } = useAlert();
    const { showConfirm } = useConfirm();

    const buscarPessoas = useCallback(async () => {
        setCarregando(true);

        try {
            const idUsuario = localStorage.getItem("userId");
            const dados = await obterPessoasComSaidaNaoAutorizada(idUsuario);
            setPessoas(dados);
        } catch (erro) {
            console.error("Erro ao obter pessoas não autorizadas:", erro);
            showAlert("Erro ao buscar autorizações de saída.", "erro");
        } finally {
            setCarregando(false);
        }
    }, [showAlert]);

    useEffect(() => {
        buscarPessoas();
    }, [buscarPessoas]);

    const normalizarValor = (valor) => normalizeString(valor || "");
    const filtroNormalizado = normalizarValor(filtro);
    const pessoasFiltradas = pessoas.filter(
        (pessoa) =>
            normalizarValor(pessoa.nomeCompleto).includes(filtroNormalizado) ||
            normalizarValor(pessoa.placaVeiculo).includes(filtroNormalizado) ||
            normalizarValor(pessoa.nomeResponsavel).includes(filtroNormalizado)
    );

    const alternarCartao = (idRegistro) => {
        setCartaoExpandidoId((idAtual) =>
            idAtual === idRegistro ? null : idRegistro
        );
    };

    const autorizarSaidaDaPessoa = (pessoa) => {
        showConfirm(
            `Deseja autorizar a saída de ${pessoa.nomeCompleto}?`,
            async () => {
                try {
                    setCarregando(true);
                    await autorizarSaida(
                        pessoa.idRegistro,
                        localStorage.getItem("fullName").toUpperCase()
                    );
                    showAlert("Autorização realizada com sucesso!", "sucesso");
                    setCartaoExpandidoId(null);
                    await buscarPessoas();
                } catch (erro) {
                    if (erro.response) {
                        showAlert(
                            `Erro! ${erro.response.data.error}.`,
                            "erro"
                        );
                    } else {
                        showAlert(
                            "Erro desconhecido, contate o administrador do sistema!",
                            "erro"
                        );
                    }
                } finally {
                    setCarregando(false);
                }
            },
            () => {}
        );
    };

    return (
        <div className="autorizacaoSaidaMobile-tela">
            {carregando && <Loading />}
            <div className="autorizacaoSaidaMobile-header">
                <h1>Autorização de Saída</h1>
            </div>

            <div className="autorizacaoSaidaMobile-container">
                <div className="autorizacaoSaidaMobile-pesquisa">
                    <input
                        type="text"
                        placeholder="Pesquisar por nome, placa ou responsável..."
                        value={filtro}
                        onChange={(evento) => setFiltro(evento.target.value)}
                    />
                </div>

                <div className="autorizacaoSaidaMobile-lista">
                    {!carregando && pessoasFiltradas.length === 0 ? (
                        <p className="autorizacaoSaidaMobile-semRegistro">
                            Nenhuma autorização de saída encontrada.
                        </p>
                    ) : (
                        pessoasFiltradas.map((pessoa) => {
                            const expandido =
                                cartaoExpandidoId === pessoa.idRegistro;

                            return (
                                <div
                                    className="autorizacaoSaidaMobile-card"
                                    key={pessoa.idRegistro}
                                >
                                    <button
                                        type="button"
                                        className="autorizacaoSaidaMobile-cardHeader"
                                        onClick={() =>
                                            alternarCartao(pessoa.idRegistro)
                                        }
                                        aria-expanded={expandido}
                                    >
                                        <strong>{pessoa.nomeCompleto}</strong>
                                        <span>
                                            {pessoa.placaVeiculo || "Sem placa"}
                                        </span>
                                    </button>

                                    {expandido && (
                                        <div className="autorizacaoSaidaMobile-cardDetalhes">
                                            <div className="autorizacaoSaidaMobile-informacoes">
                                                <p>
                                                    <strong>Responsável:</strong>{" "}
                                                    {pessoa.nomeResponsavel}
                                                </p>
                                                <p>
                                                    <strong>Data:</strong>{" "}
                                                    {formatarDataBrasilia(
                                                        pessoa.dataHoraEntrada
                                                    )}
                                                </p>
                                                <p>
                                                    <strong>Hora:</strong>{" "}
                                                    {formatarHoraBrasilia(
                                                        pessoa.dataHoraEntrada
                                                    )}
                                                </p>
                                            </div>
                                            <button
                                                type="button"
                                                className="autorizacaoSaidaMobile-botaoAutorizar"
                                                onClick={() =>
                                                    autorizarSaidaDaPessoa(pessoa)
                                                }
                                            >
                                                Autorizar Saída
                                            </button>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

export default AutorizacaoSaidaMobile;
